import $ from 'jquery';
import { simpleSelectInit } from '../simpleSelect/simpleSelect';
import { dataNextPage, favouriteButtonSelector, moreButtonSelector, active } from './constants';
import { search } from './search';
import { tutorUrl, isTutorRoute, isTutorLessonRoute } from '../routes';

const isFavouriteInputId = 'lessonlistsearchform-is_favourite';
const searchInputId = 'lessons-search';
const tutorSearchForm = 'tutor-search-form';
const isFavouriteInputSelector = '#' + isFavouriteInputId;
const tutorSearchFormSelector = '#' + tutorSearchForm;
const searchInputSelector = '#' + searchInputId;
const checked = 'checked';
const enter = 'Enter';

const updateFavouriteButton = (target, isActive) => {
    const $favouriteButton = $(target).closest(favouriteButtonSelector);

    if (isActive) {
        $favouriteButton.addClass(active);

        return;
    }

    $favouriteButton.removeClass(active);
}

const setFilterFavourite = e => {
    const $formInput = $(isFavouriteInputSelector);
    const isActive = $formInput.prop(checked);

    $formInput.prop(checked, !isActive);
    updateFavouriteButton(e.target, !isActive);
    search();
}

const blockSubmit = e => {
    if (e.key !== enter) {
        return;
    }

    e.preventDefault();
    e.target.blur();
}

const moreButtonClickHandler = function () {
    search($(this).attr(dataNextPage));
}

export const tutorSearchHandlers = () => {
    if (!isTutorRoute) {
        return;
    }

    if (isTutorLessonRoute) {
        return;
    }

    $(tutorSearchFormSelector).on('submit', e => { e.preventDefault(); });

    $('.tutor-clear-filters-button').on('click', () => {
        window.location.href = tutorUrl;
    });

    $(favouriteButtonSelector + ' svg').on('click', setFilterFavourite);

    $(searchInputSelector).on('keydown', blockSubmit);

    $(tutorSearchFormSelector).on('change', search);

    $(moreButtonSelector).on('click', moreButtonClickHandler);

    simpleSelectInit('lessons-all-skills');
    simpleSelectInit('lessons-all-categories');
    simpleSelectInit('lessons-sort-field');
};
